import { Link, NavLink, Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../../lib/auth";
import {
  LayoutDashboard, Newspaper, FolderTree, Users2, Image as ImgIcon,
  Megaphone, MessageSquare, UserCog, LogOut,
} from "lucide-react";

const NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true, roles: ["admin","editor","journalist"] },
  { to: "/admin/noticias", label: "Notícias", icon: Newspaper, roles: ["admin","editor","journalist"] },
  { to: "/admin/categorias", label: "Categorias", icon: FolderTree, roles: ["admin","editor"] },
  { to: "/admin/autores", label: "Autores", icon: Users2, roles: ["admin","editor"] },
  { to: "/admin/banners", label: "Banners", icon: ImgIcon, roles: ["admin","editor"] },
  { to: "/admin/anuncios", label: "Anúncios", icon: Megaphone, roles: ["admin","editor"] },
  { to: "/admin/comentarios", label: "Comentários", icon: MessageSquare, roles: ["admin","editor"] },
  { to: "/admin/usuarios", label: "Usuários", icon: UserCog, roles: ["admin"] },
];

export default function AdminLayout({ children }) {
  const { user, loading, logout } = useAuth();
  const navigate = useNavigate();

  if (loading) return <div className="min-h-screen flex items-center justify-center font-sans-ui text-zinc-500">Carregando...</div>;
  if (!user) return <Navigate to="/admin/login" replace />;

  const doLogout = async () => { await logout(); navigate("/admin/login"); };

  return (
    <div className="min-h-screen bg-zinc-50 flex" data-testid="admin-layout">
      <aside className="w-64 bg-black text-white flex-shrink-0 flex flex-col" data-testid="admin-sidebar">
        <Link to="/admin" className="px-6 py-6 border-b border-zinc-800">
          <h1 className="font-serif-display text-xl font-bold leading-tight">Chiquinho</h1>
          <p className="font-sans-ui text-xs text-zinc-400 mt-0.5">Painel Admin</p>
        </Link>
        <nav className="flex-1 py-4">
          {NAV.filter(n => n.roles.includes(user.role)).map(n => (
            <NavLink key={n.to} to={n.to} end={n.end} className={({isActive}) =>
              `flex items-center gap-3 px-6 py-2.5 font-sans-ui text-sm hover:bg-zinc-900 ${isActive ? "bg-zinc-900 border-l-2 border-red-700" : ""}`
            } data-testid={`admin-nav-${n.label.toLowerCase()}`}>
              <n.icon size={16} />
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-zinc-800 px-6 py-4">
          <p className="font-sans-ui text-sm font-semibold">{user.name}</p>
          <p className="font-sans-ui text-xs text-zinc-400 capitalize">{user.role}</p>
          <button onClick={doLogout} className="mt-3 flex items-center gap-2 text-xs font-sans-ui text-red-400 hover:text-red-300" data-testid="admin-logout">
            <LogOut size={12}/> Sair
          </button>
        </div>
      </aside>
      <main className="flex-1 overflow-x-auto">
        <div className="p-8">{children}</div>
      </main>
    </div>
  );
}
